module.exports = __webpack_public_path__ + "assets/travail-laptop.0eef8c27e03021ff03caf1cd6bb58e20.svg";